import { useUserMe } from 'shared/api/userMeQuery'
import { useMemo } from 'react'
import { getTenantNameFromAddressbar } from 'shared/utils/url'
import {
  trackMovieTagAttach as baseTrackMovieTagAttach,
  trackUserInvite as baseTrackUserInvite,
  trackUserEdit as baseTrackUserEdit,
  trackUserDelete as baseTrackUserDelete,
  trackDeviceEdit as baseTrackDeviceEdit,
  trackDeviceAreaMove as baseTrackDeviceAreaMove,
  trackAreaAdd as baseTrackAreaAdd,
  trackAreaEdit as baseTrackAreaEdit,
  trackTagCreate as baseTrackTagCreate,
  trackTagDelete as baseTrackTagDelete,
  trackClipEdit as baseTrackClipEdit,
  trackClipDelete as baseTrackClipDelete,
  trackLogout as baseTrackLogout,
  trackRecordPlayOpen as baseTrackRecordPlayOpen,
  trackClipCreate as baseTrackClipCreate,
  trackViewerOpen as baseTrackViewerOpen,
  trackPanTiltUse as baseTrackPanTiltUse,
  trackZoomUse as baseTrackZoomUse,
  trackSoftwareZoomUse as baseTrackSoftwareZoomUse,
  trackPresetMove as baseTrackPresetMove,
  trackPresetAdd as baseTrackPresetAdd,
  trackPresetDelete as baseTrackPresetDelete,
  trackHomePositionSet as baseTrackHomePositionSet,
  trackHomePositionMove as baseTrackHomePositionMove
} from 'shared/utils/gtm'

export const useGTM = () => {
  const userMe = useUserMe()

  const userId = useMemo(() => userMe?.id, [userMe?.id])

  // この管理画面は SPA で SSR / prerender の経路が無く、shared/utils/url の
  // getViewerUrl / getRedirectUrl も window.location を直に読んでいる。
  // ここだけ window の有無を見ても意味が無いので前提を揃える
  const tenantName = useMemo(() => getTenantNameFromAddressbar(window.location.href), [])

  return {
    trackMovieTagAttach: (cameraId: string) => baseTrackMovieTagAttach(cameraId, userId, tenantName),
    trackUserInvite: () => baseTrackUserInvite(userId, tenantName),
    trackUserEdit: () => baseTrackUserEdit(userId, tenantName),
    trackUserDelete: () => baseTrackUserDelete(userId, tenantName),
    trackDeviceEdit: (cameraId: string) => baseTrackDeviceEdit(cameraId, userId, tenantName),
    trackDeviceAreaMove: (cameraId: string) => baseTrackDeviceAreaMove(cameraId, userId, tenantName),
    trackAreaAdd: () => baseTrackAreaAdd(userId, tenantName),
    trackAreaEdit: () => baseTrackAreaEdit(userId, tenantName),
    trackTagCreate: () => baseTrackTagCreate(userId, tenantName),
    trackTagDelete: () => baseTrackTagDelete(userId, tenantName),
    trackClipEdit: (cameraId: string) => baseTrackClipEdit(cameraId, userId, tenantName),
    trackClipDelete: (cameraId: string) => baseTrackClipDelete(cameraId, userId, tenantName),
    trackLogout: () => baseTrackLogout(userId, tenantName),
    trackRecordPlayOpen: (cameraId: string) => baseTrackRecordPlayOpen(cameraId, userId, tenantName),
    trackClipCreate: (cameraId: string) => baseTrackClipCreate(cameraId, userId, tenantName),
    trackViewerOpen: (cameraId: string) => baseTrackViewerOpen(cameraId, userId, tenantName),
    trackPanTiltUse: (cameraId: string) => baseTrackPanTiltUse(cameraId, userId, tenantName),
    trackZoomUse: (cameraId: string) => baseTrackZoomUse(cameraId, userId, tenantName),
    trackSoftwareZoomUse: (cameraId: string) => baseTrackSoftwareZoomUse(cameraId, userId, tenantName),
    trackPresetMove: (cameraId: string) => baseTrackPresetMove(cameraId, userId, tenantName),
    trackPresetAdd: (cameraId: string) => baseTrackPresetAdd(cameraId, userId, tenantName),
    trackPresetDelete: (cameraId: string) => baseTrackPresetDelete(cameraId, userId, tenantName),
    trackHomePositionSet: (cameraId: string) => baseTrackHomePositionSet(cameraId, userId, tenantName),
    trackHomePositionMove: (cameraId: string) => baseTrackHomePositionMove(cameraId, userId, tenantName)
  }
}
